import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const generateInvoicePDF = async (invoiceElement) => {
  if (!invoiceElement) {
    console.error('Invoice element not found');
    return;
  }

  try {
    const invoiceDivs = invoiceElement.querySelectorAll(':scope > div');
    const pdf = new jsPDF({
      orientation: 'l', // Landscape orientation
      unit: 'px',
      format: [595, 420], // A5 landscape dimensions in px
      // compress: true
    });

    for (let i = 0; i < invoiceDivs.length; i++) {
      const div = invoiceDivs[i];

      const canvas = await html2canvas(div, {
        scale: 2,
        useCORS: true,
        logging: false,
        allowTaint: true,
        backgroundColor: '#ffffff', // Ensures a white background
      });

      // const imgData = canvas.toDataURL('image/png');
      const imgData = canvas.toDataURL('image/jpeg', 1);
      const imgWidth = 595; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      const xOffset = 0;
      const yOffset = (420 - imgHeight) / 2; 

      if (i > 0) {
        pdf.addPage();
      }

      pdf.addImage(imgData, 'PNG', xOffset, yOffset, imgWidth, imgHeight);
    }

    pdf.save(`Invoice-${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('PDF generation error:', error);
  }
};

// Usage in a component
// export const usePDFDownload = (invoiceRef) => {
//   const handleDownloadPDF = () => {
//     if (invoiceRef.current) {
//       generateInvoicePDF(invoiceRef.current);
//     }
//   };

//   return handleDownloadPDF;
// };

// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

// export const generateOptimizedInvoicePDF = async (invoiceElement) => {
//   if (!invoiceElement) {
//     console.error('Invoice element not found');
//     return;
//   }

//   try {
//     // Get all direct child divs
//     const invoiceDivs = invoiceElement.querySelectorAll(':scope > div');
    
//     // Create PDF
//     const pdf = new jsPDF({
//       orientation: 'l',
//       unit: 'px',
//       format: [595, 420],
//       compress: true
//     });

//     // Process divs sequentially to reduce memory pressure
//     for (let i = 0; i < invoiceDivs.length; i++) {
//       const div = invoiceDivs[i];

//       // Use a lower resolution and JPEG for performance and size
//       const canvas = await html2canvas(div, {
//         scale: 1, // Reduced from 2
//         useCORS: true,
//         logging: false,
//         allowTaint: true,
//         backgroundColor: '#ffffff',
//       });

//       // Convert to JPEG with compression
//       const imgData = canvas.toDataURL('image/jpeg', 0.6);
      
//       // Calculate dimensions
//       const imgWidth = 595; 
//       const imgHeight = (canvas.height * imgWidth) / canvas.width;

//       // Calculate vertical centering
//       const yOffset = (420 - imgHeight) / 2;

//       // Add page
//       if (i > 0) {
//         pdf.addPage();
//       }

//       // Add image to PDF
//       pdf.addImage(imgData, 'JPEG', 0, yOffset, imgWidth, imgHeight);
//     }

//     // Save or download the PDF
//     pdf.save(`Invoice-${new Date().toISOString().split('T')[0]}.pdf`);

//   } catch (error) {
//     console.error('PDF generation error:', error);
//     throw error; // Rethrow to allow error handling in the calling component
//   }
// };

// // Async hook for React components
// export const usePDFDownload = (invoiceRef) => {
//   const handleDownloadPDF = async () => {
//     if (invoiceRef.current) {
//       try {
//         await generateOptimizedInvoicePDF(invoiceRef.current);
//       } catch (error) {
//         // Optional: Add error handling logic
//         console.error('PDF download failed', error);
//       }
//     }
//   };

//   return handleDownloadPDF;
// };